import { render, staticRenderFns } from "./ReturnSchool3.vue?vue&type=template&id=70f06ab8&scoped=true&"
import script from "./ReturnSchool3.vue?vue&type=script&lang=js&"
export * from "./ReturnSchool3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f06ab8",
  null
  
)

export default component.exports